// extracted by mini-css-extract-plugin
module.exports = {"container":"AuctionButton_container__PpntT","errorMessageAlert":"AuctionButton_errorMessageAlert__1qOuc"};